<template>
  <admin title="Planos" menu="Planos">
    <div class="row">
      <div class="col-lg-10 col-xs-12">
        <div class="block_info_white bg_black p-2">
          <div class="row">
            <div class="col-lg-5 col-xs-12">
              <div class="form-group mb-0 has-search">
                <input
                  type="text"
                  v-model="search"
                  v-on:keyup.enter="searchPlans"
                  class="form-control no_border bg_grey"
                  placeholder="Search"
                />
              </div>
            </div>
            <div class="col-lg-5 col-xs-12"></div>
            <div class="col-lg-2 col-xs-12">
              <div class="pt-2">
                <span class="mr-2 color-light-grey">
                  <b>Total</b>
                </span>
                <span class="block_info">
                  <b>{{ totalPlans }}</b>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-xs-12 pl-0">
        <inertia-link href="/admins/plans/new">
          <button type="button" class="btn full btn-degrade right">
            <b>Novo Plano</b>
          </button>
        </inertia-link>
      </div>
      <div class="col-lg-12 col-xs-12">
        <div class="row">
          <div class="col-lg-12">
            <table class="table_jovool table_jovool_dark mt-3">
              <thead class="headerTable">
                <tr class="text-center">
                  <td class="center">
                    Nome
                    <OrderTable field="name" entity="plan" />
                  </td>
                  <td class="center">
                    Preço
                    <OrderTable field="price" entity="plan" />
                  </td>
                  <td class="center">
                    Qtd Vaga
                    <OrderTable field="amount_jobs" entity="plan" />
                  </td>
                  <td class="center">
                    Visibilidade
                    <OrderTable field="visibility" entity="plan" />
                  </td>
                  <td class="center">
                    Status
                    <OrderTable field="status" entity="plan" />
                  </td>
                  <td class="center">
                    Data Criaçao
                    <OrderTable field="created_at" entity="plan" />
                  </td>
                  <td></td>
                </tr>
              </thead>
              <tbody class="position-relative">
                <tr
                  v-for="(plan, index) in plans"
                  :key="plan.id"
                  :class="{'content-loading': loading}"
                >
                  <td class="center">
                    <div>{{plan.name}}</div>
                  </td>

                  <td class="pt-4 center">
                    <span class="d-inline-block text-truncate" style="max-width: 200px">
                      R$
                      {{ plan.price ? parseFloat(plan.price).toFixed(2).replace('.', ',') : "0,00" }}
                    </span>
                  </td>
                  <td class="pt-4 center">
                    <span>{{plan.amount_jobs}}</span>
                  </td>

                  <td>
                    <div
                      class="mt-1 block_process"
                      :class="{process3: plan.visibility, process0: !plan.visibility }"
                    >{{ plan.visibility ? 'Sim': 'Não'}}</div>
                  </td>

                  <td>
                    <div
                      class="mt-1 block_process"
                      :class="{process1: plan.status, process0: !plan.status }"
                    >{{ plan.status ? 'Ativo': 'Desativado'}}</div>
                  </td>
                  <td class="pt-4 center">
                    {{
                    plan.created_at | moment("DD/MM/YYYY")
                    }}
                  </td>
                  <td>
                    <inertia-link :href="'/admins/plans/'+plan.id+'/edit'">
                      <i class="fas f25 color-light-grey fa-file-alt"></i>
                    </inertia-link>
                  </td>
                </tr>
                <div class="center position-absolute loading-gif" :class="{'d-none': !loading }">
                  <img src="/images/loading.gif" alt="loading-gif" />
                </div>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <v-pagination
      v-model="currentPage"
      :page-count="pageCount"
      class="justify-content-center mt-3"
      :class="'d-flex'"
      :classes="bootstrapPaginationClasses"
    ></v-pagination>
  </admin>
</template>

<script>
import vPagination from "vue-plain-pagination";
import OrderTable from "components/OrderTable.vue";
export default {
  components: { vPagination, OrderTable },
  data: () => ({
    search: "",
    currentPage: 1,
    pageCount: 1,
    loading: true,
    totalPlans: 0,
    field: "",
    order: "",
    plans: [],
    bootstrapPaginationClasses: {
      ul: "pagination",
      li: "page-item",
      liActive: "active",
      liDisable: "disabled",
      button: "page-link",
    },
  }),
  mounted() {
    setTimeout(() => {
      this.searchPlans();
    }, 800);
    eventBus.$on("orderColumnplan", (fields) => {
      this.field = fields.field;
      this.order = fields.order;
      this.searchPlans();
    });
  },
  methods: {
    searchPlans() {
      let params = {};

      if (this.field != "") {
        params["order"] = {};
        params["order"][this.field] = this.order;
      }
      params["search"] = this.search;
      if (this.search == "") {
        params["search"] = "*";
      }
      this.loading = true;
      axios
        .get(`/admins/plans/search/?page=${this.currentPage}`, {
          params: params,
        })
        .then((response) => {
          this.plans = response.data.plans;
          this.totalPlans = response.data.total_plans;
          this.pageCount = Math.ceil(this.totalPlans / 10);
          this.loading = false;
          return;
        });
    },
  },
};
</script>